<template>
  <div id="app">
    <front-menu></front-menu>
    <!-- <div class="bg" ref="bg">
        <h2>HAHAH</h2>
    </div> -->
    <transition name="fade">
        <router-view/>
    </transition>
  </div>
</template>

<script>
import MenuComponent from '@/components/MenuComponent'
import {TweenMax, Power2, TimelineLite} from "gsap/TweenMax";

export default {
    components: {
        'front-menu': MenuComponent
    },
    data() {
        return {
            
        }
    },
    methods: {
        // animate(done) {
        //     TweenLite.fromTo(this.$refs.bg, 0.8, 
        //         { 
        //           css: {
        //              height: 0
        //           }
        //         },
        //         {  
        //           css: {
        //               height: '50vh'
        //           }, onComplete: function() { done() }
        //         },
        //     );
        // },
        // enter(el, done) {
        //     this.animate(done);
        // },
        // afterEnter() {
        //     TweenLite.fromTo(this.$refs.bg, 0.8, 
        //         { 
        //           css: {
        //              height: '50vh'
        //           }
        //         },
        //         {  
        //           css: {
        //               left: '50vw'
        //           }
        //         },
        //     );    
        // },
        // leave(el, done) {
        //     this.animate();
        // }
    },
}
</script>

<style scoped lang="scss">
* {
    margin: 0px;
    padding: 0px;
}

.bg {
  opacity: 0.3;
    position: fixed;
    background-color: red;
    z-index: 999;
    top: 0;
    left: 0;
    width: 100%;

    display: flex;
    align-items: center;
    justify-content: center;
}


</style>
